import React from "react";

import { TooltipDirection } from "../../enums";

interface TableCellProps {
  children: React.ReactNode;
  hasTooltip?: boolean;
  tooltipDirection?: TooltipDirection ;
}

export const TableCell: React.FC<TableCellProps> = ({ children, hasTooltip, tooltipDirection }) => {

  return (
    <div className={`table-col ${children && hasTooltip ? "has-tooltip" : ""}`}>
      {children || "-"}
      {
        hasTooltip && (
          <div className={`tooltip-wrp ${tooltipDirection || ""}`}>
            <div className="tooltip-wrp-inner">
              <p className="tooltip-wrp-info">
                {children}
              </p>
            </div>
          </div>
        )
      }
    </div>
  )
};
